import axios from "axios";
import { logout } from "./axiosClient";

export function createAxiosClient({ options, getCurrentAccessToken }: any) {
  const client = axios.create(options);
  let isRefreshing = false;
  client.interceptors.request.use(
    (config: any) => {
      const token = getCurrentAccessToken();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  client.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      if (error.response === undefined) {
        // Internet failure or server disconnected
      } else if (error.response.status === 401) {
        const refreshToken = localStorage.getItem("refreshToken");

        if (!refreshToken) {
          logout();
          return Promise.reject(error);
        }

        if (!isRefreshing) {
          isRefreshing = true;

          try {
            const response = await axios.post(
              "https://devg2iapi.sequspace.com/auth/refresh-access-token",
              {
                refreshToken,
              },
            );

            const newAccessToken = response.data.data.accessToken;

            const newRefreshToken = response.data.data.refreshToken;

            localStorage.setItem("accessToken", newAccessToken);

            localStorage.setItem("refreshToken", newRefreshToken);

            error.config.headers.Authorization = newAccessToken;

            isRefreshing = false;

            return client(error.config);
          } catch (refreshError) {
            isRefreshing = false;
            logout();
            return Promise.reject(refreshError);
          }
        }
      }

      return Promise.reject(error);
    },
  );

  return client;
}
